import { Component } from "@angular/core";

@Component({
    selector: "clare-email-under-different-dealer-dialog",
    templateUrl: "./email-under-different-dealer-dialog.component.html",
})
export class EmailUnderDifferentDealerComponent {}
